module.exports = __webpack_public_path__ + "img/background-study-investor@2x.f2ff8150.jpg";